import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <img src="/ec_logo_white.png" alt="TDS Event Center" className="footer-logo" />
        <p className="footer-text">
          Website powered by{' '}
          <a
            className="footer-brand"
            href="https://www.lakesidedigitalmn.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Lakeside Digital
          </a>
        </p>
        <a
          className="footer-social"
          href="https://www.facebook.com/p/Fertile-Events-Group-61577790920978/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Fertile Events Group on Facebook"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M22 12.07C22 6.48 17.52 2 11.93 2S1.86 6.48 1.86 12.07c0 4.95 3.6 9.06 8.3 9.9v-7.01H7.7V12.07h2.46V9.85c0-2.43 1.45-3.77 3.66-3.77 1.06 0 2.16.19 2.16.19v2.38h-1.22c-1.2 0-1.57.74-1.57 1.5v1.81h2.67l-.43 2.89h-2.24v7.01c4.7-.84 8.3-4.95 8.3-9.9z" />
          </svg>
        </a>
      </div>
    </footer>
  );
};

export default Footer;




